import React, { useState } from "react";
import { Crown, Truck, Tag, Headset, CheckCircle, WhatsappLogo, Package, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, WHATSAPP_NUMBER } from "../lib/api";

const benefits = [
  { icon: Tag, t: "Precios especiales", d: "Tarifas preferenciales por volumen a partir de 18 cervezas." },
  { icon: Headset, t: "Atención VIP", d: "Un asesor dedicado para tu negocio o evento, de principio a fin." },
  { icon: Truck, t: "Entrega coordinada", d: "Coordinamos la logística de tu pedido a mayor." },
  { icon: Crown, t: "Surtido a medida", d: "Arma tu mezcla de estilos y ediciones especiales GARAJE." },
];

export default function VentasMayor() {
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", quantity: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    const qty = parseInt(form.quantity);
    if (!form.name.trim() || !/^\S+@\S+\.\S+$/.test(form.email) || form.phone.trim().length < 7) {
      toast.error("Completa nombre, correo y teléfono válidos");
      return;
    }
    if (!qty || qty < 18) {
      toast.error("La cantidad mínima al mayor es 18 cervezas");
      return;
    }
    setLoading(true);
    try {
      const res = await api.post("/mayor-requests", { ...form, quantity: qty });
      setDone(res.data);
      toast.success("¡Solicitud enviada!");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "No se pudo enviar. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const whatsapp = () => {
    const msg = `¡Hola Ciudad Garaje! 🍺 Quiero cotizar una VENTA AL MAYOR (+18 cervezas).\n\nNombre: ${form.name || "-"}\nNegocio: ${form.company || "-"}\nCantidad: ${form.quantity || "-"}${done ? `\nSolicitud: ${done.reference}` : ""}`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <div>
      {/* HERO */}
      <section className="relative grain overflow-hidden border-b border-white/10 bg-[#0d0d0d]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 border border-[#D97736]/50 text-[#F5A623] px-3 py-1.5 mb-6">
              <Crown size={16} weight="fill" /> <span className="overline text-[#F5A623]">Atención VIP · Mayoristas</span>
            </div>
            <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.9]">
              Ventas al <span className="text-[#D97736]">mayor</span>
            </h1>
            <p className="text-gray-300 text-base md:text-lg mt-6 max-w-xl leading-relaxed">
              ¿Bar, restaurante, licorería o evento grande? A partir de <span className="text-white font-semibold">18 cervezas</span> accedes a precios especiales y una atención VIP dedicada.
            </p>
            <a href="#cotizar" className="inline-flex items-center gap-2 mt-9 bg-[#D97736] hover:bg-[#E88D50] text-black font-semibold uppercase tracking-wide px-7 py-4 transition-colors hover:-translate-y-0.5" style={{ transitionProperty: "background-color, transform" }} data-testid="mayor-cotizar-cta">
              Cotizar al mayor <ArrowRight size={18} weight="bold" />
            </a>
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-20">
        <div className="overline text-[#F5A623] mb-3">Beneficios mayoristas</div>
        <h2 className="font-display text-5xl md:text-6xl leading-none mb-10">Trato VIP para tu negocio</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {benefits.map((b) => (
            <div key={b.t} className="bg-[#141414] p-8 hover:bg-[#1a1a1a] transition-colors" data-testid={`mayor-benefit-${b.t}`}>
              <div className="w-12 h-12 border border-[#D97736]/50 flex items-center justify-center text-[#D97736] mb-5"><b.icon size={24} weight="duotone" /></div>
              <h3 className="font-display text-2xl">{b.t}</h3>
              <p className="text-gray-400 text-sm mt-2">{b.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FORM */}
      <section id="cotizar" className="border-t border-white/10 bg-[#0d0d0d]">
        <div className="max-w-3xl mx-auto px-5 md:px-8 py-16 md:py-24">
          <div className="text-center mb-10">
            <div className="overline text-[#F5A623] mb-2">Cotización</div>
            <h2 className="font-display text-5xl md:text-6xl leading-none">Solicita tu cotización</h2>
            <p className="text-gray-400 mt-3">Mínimo 18 cervezas. Te contactamos con tu precio VIP.</p>
          </div>

          {done ? (
            <div className="border border-[#25D366]/40 bg-[#141414] p-8 text-center" data-testid="mayor-success">
              <CheckCircle size={56} weight="fill" className="mx-auto text-[#25D366]" />
              <h3 className="font-display text-4xl mt-5">¡Gracias, {done.name?.split(" ")[0]}!</h3>
              <p className="text-gray-300 mt-3">Recibimos tu solicitud <span className="text-[#D97736] font-semibold">{done.reference}</span>. Un asesor VIP te contactará con tu cotización al mayor. 🍺</p>
              <button onClick={whatsapp} className="mt-6 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-black font-semibold uppercase tracking-wide px-6 py-4 transition-colors" data-testid="mayor-whatsapp-btn">
                <WhatsappLogo size={20} weight="fill" /> Adelantar por WhatsApp
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="bg-[#171717] border border-white/10 p-6 md:p-8 space-y-6" data-testid="mayor-form">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label className="overline block mb-2">Nombre</label>
                  <input value={form.name} onChange={(e) => set("name", e.target.value)} className="w-full bg-transparent border-b border-white/20 focus:border-[#D97736] outline-none py-3 text-white" placeholder="Tu nombre" data-testid="mayor-name" />
                </div>
                <div>
                  <label className="overline block mb-2">Negocio (opcional)</label>
                  <input value={form.company} onChange={(e) => set("company", e.target.value)} className="w-full bg-transparent border-b border-white/20 focus:border-[#D97736] outline-none py-3 text-white" placeholder="Bar, restaurante..." data-testid="mayor-company" />
                </div>
                <div>
                  <label className="overline block mb-2">Correo</label>
                  <input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="w-full bg-transparent border-b border-white/20 focus:border-[#D97736] outline-none py-3 text-white" placeholder="tucorreo@ejemplo.com" data-testid="mayor-email" />
                </div>
                <div>
                  <label className="overline block mb-2">Teléfono</label>
                  <input value={form.phone} onChange={(e) => set("phone", e.target.value)} className="w-full bg-transparent border-b border-white/20 focus:border-[#D97736] outline-none py-3 text-white" placeholder="0414 000 0000" data-testid="mayor-phone" />
                </div>
                <div className="sm:col-span-2">
                  <label className="overline block mb-2 flex items-center gap-1"><Package size={14} /> Cantidad de cervezas (mín. 18)</label>
                  <input type="number" min="18" value={form.quantity} onChange={(e) => set("quantity", e.target.value)} className="w-full bg-transparent border-b border-white/20 focus:border-[#D97736] outline-none py-3 text-white" placeholder="Ej: 48" data-testid="mayor-quantity" />
                </div>
              </div>
              <div>
                <label className="overline block mb-2">¿Qué necesitas? (opcional)</label>
                <textarea rows={3} value={form.message} onChange={(e) => set("message", e.target.value)} className="w-full bg-transparent border border-white/20 focus:border-[#D97736] outline-none p-3 text-white text-sm" placeholder="Estilos, frecuencia de compra, zona de entrega..." data-testid="mayor-message" />
              </div>
              <button type="submit" disabled={loading} className="w-full bg-[#D97736] hover:bg-[#E88D50] disabled:opacity-60 text-black font-semibold uppercase tracking-wide py-4 transition-colors" data-testid="mayor-submit">
                {loading ? "Enviando..." : "Solicitar cotización VIP"}
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
